import ErrorCriticalPage from 'view/pages/document-hub/error-critical';
import DriverSignup from './App';

export default DriverSignup;
export { ErrorCriticalPage };
